import angular from 'angular';
import '../../app.constants';
import '../../services/totem-tv';
import '../../services/errors';
import '../../services/notifications';

const module = angular.module('whyline.controllers.totem-tv-information-screen', [
  'whyline.constants',
  'whyline.services.totem-tv',
  'whyline.services.errors',
  'whyline.services.notifications',
]);

const TotemTvInformationScreenController = (SAFE_STATES, $scope, $state, $timeout, TotemTvService, ErrorService, $translate) => {
  /*@ngInject*/

  // Init
  TotemTvService.SetButtonStatus('back', true);
  TotemTvService.SetButtonStatus('forward', false);
  TotemTvService.SetButtonStatus('status-text', true);
  TotemTvService.SetButtonStatus('browserBack', true);

  $scope.informationScreen = TotemTvService.GetInformationScreen();

  let returnToHome = $timeout(() => {
    $state.go(SAFE_STATES.totemTvWelcome);
  }, 10000);

  $scope.$on('$destroy', () => {
    $timeout.cancel(returnToHome);
  });
};

module.exports = module.controller('TotemTvInformationScreenController', TotemTvInformationScreenController);
